!function(){function t(){null!==this.parentNode&&this.parentNode.removeChild(this)}[Element.prototype,CharacterData.prototype,DocumentType.prototype].forEach(function(e){e.hasOwnProperty("remove")||Object.defineProperty(e,"remove",{configurable:!0,enumerable:!0,writable:!0,value:t})})}();



//////////////////
// WEBPACK FOOTER
// ./node_modules/mdn-polyfills/Node.prototype.remove.js
// module id = 9
// module chunks = 0